<template>
  <div
    class="d-flex flex-column gr-10 text--text"
  >
    <div :class="isMobile ? 'text-h6 text-center' : 'text-h5'">
      {{ t('Зачем регистрироваться', options) }}
    </div>

    <div
      class="benefits-of-registration-list ga-10"
    >
      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-reviews-40 ui-icon_type_40 brand" />
        <div class="text-subtitle-1">
          {{ t('Отзывы пациентов', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Уведомления о новых отзывах', options) }}
          <br>— {{ t('Приватный чат с автором', options) }}
          <br>— {{ t('Публикация ответов', options) }}
        </div>
      </div>

      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-puzzle-40 ui-icon_type_40 special" />
        <div class="text-subtitle-1">
          {{ t('Формирование бренда', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Актуализация профиля', options) }}
          <br>— {{ t('Бесплатная публикация интервью', options) }}
          <br>— {{ t('Фотогалерея и видеовизитка клиники', options) }}
        </div>
      </div>

      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-family-40 ui-icon_type_40 success" />
        <div class="text-subtitle-1">
          {{ t('Новые пациенты', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Запись к врачам', options) }}
          <br>— {{ t('Запись на услуги и диагностику', options) }}
          <br>— {{ t('Бесплатная выгрузка расписания', options) }}
        </div>
      </div>

      <template v-if="context.request.country.is_russia">
        <div class="d-flex flex-column gr-4 flex-grow-1">
          <div class="ui-icon-ads-40 ui-icon_type_40 secondary" />
          <div class="text-subtitle-1">
            {{ t('Умная реклама', options) }}
          </div>
          <div class="text-body-2 text-secondary--text">
            — {{ t('Настраиваемый таргетинг', options) }}
            <br>— {{ t('Спецразмещение клиник и врачей в каталоге', options) }}
          </div>
        </div>

        <div class="d-flex flex-column gr-4 flex-grow-1">
          <div class="ui-icon-rating-40 ui-icon_type_40 warning" />
          <div class="text-subtitle-1">
            {{ t('Партнерская программа', options) }}
          </div>
          <div class="text-body-2 text-secondary--text">
            — {{ t('Отсутствие рекламы на странице клиники', options) }}
            <br>— {{ t('Отсутствие раздела «другие клиники города»', options) }}
            <br>— {{ t('Сбор и визуализация аналитики', options) }}
          </div>
        </div>

        <div class="d-flex flex-column gr-4 flex-grow-1">
          <div class="ui-icon-pd-40 ui-icon_type_40 primary" />
          <div class="text-subtitle-1">
            {{ t('Другие преимущества «ПроДокторов»', options) }}
          </div>

          <a
            :href="`https://${context.site_expert.domain}/`"
            class="text-body-2 link-decoration-none primary--text"
          >
            {{ t('Узнать про все преимущества', options) }}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/lpus/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.benefits-of-registration-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(226px, 1fr));

  @media (max-width: 789.98px) {
    text-align: center;

    & > * {
      align-items: center;
    }
  }
}
</style>
